function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "faa263ba-4d93-43f3-8f6b-5c0bfeed2f5a",
  x1: 435.95428,
  y1: 161.22673,
  x2: 435.95428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e7b3f2b9-2797-469d-a8e7-bdddf2d3c493",
  x1: 895.45571,
  y1: 298.73532,
  x2: 895.45571,
  y2: 178.44409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b3b3b3",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53514,
  stopColor: "#b3b3b3",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3",
  stopOpacity: 0.05
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b8dc7ddd-0e76-4866-9241-0076e20120d3",
  x1: 858.28282,
  y1: 221.34343,
  x2: 858.28282,
  y2: 215.55356,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55135,
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "febfb89e-07b1-4842-b918-627d114e5328",
  x1: 884.87591,
  y1: 214.70119,
  x2: 884.87591,
  y2: 196.99804,
  xlinkHref: "#b8dc7ddd-0e76-4866-9241-0076e20120d3"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Search");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 871.90856,
  height: 161.22673,
  fill: "url(#faa263ba-4d93-43f3-8f6b-5c0bfeed2f5a)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 5.09144,
  y: 5.27725,
  width: 860.45283,
  height: 147.3786,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 57.93932,
  y: 35.36492,
  width: 500.19403,
  height: 87.71321,
  fill: "#f5f5f5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M916.21229,192.66152a46.319,46.319,0,1,0-7.57811,70.55358l33.4839,34.82841a2.25386,2.25386,0,0,0,3.18682.06273l8.34443-8.02231a2.25386,2.25386,0,0,0,.06272-3.18681l-33.4839-34.82842A46.32213,46.32213,0,0,0,916.21229,192.66152Zm-10.42905,55.9852a33.13094,33.13094,0,1,1,.922-46.84515A33.131,33.131,0,0,1,905.78324,248.64672Z",
  transform: "translate(-164.04572 -151.70001)",
  fill: "url(#e7b3f2b9-2797-469d-a8e7-bdddf2d3c493)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M858.28282,215.55356c-3.72547,0-3.73167,5.78987,0,5.78987C862.0083,221.34343,862.0145,215.55356,858.28282,215.55356Z",
  transform: "translate(-164.04572 -151.70001)",
  fill: "url(#b8dc7ddd-0e76-4866-9241-0076e20120d3)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M884.25427,197.00541a27.82923,27.82923,0,0,0-24.00514,12.39878c-1.58285,2.47751,2.91112,4.66665,4.48548,2.2024,4.01726-6.28806,11.65182-10.28019,19.90217-10.07359a25.35931,25.35931,0,0,1,20.6949,12.03672c1.58209,2.60731,5.72583.2365,4.15387-2.354C904.43151,202.88689,894.61425,197.23994,884.25427,197.00541Z",
  transform: "translate(-164.04572 -151.70001)",
  fill: "url(#febfb89e-07b1-4842-b918-627d114e5328)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M916.21229,187.57009a46.319,46.319,0,1,0-7.57811,70.55357l33.4839,34.82842a2.25387,2.25387,0,0,0,3.18682.06272l8.34443-8.0223a2.25387,2.25387,0,0,0,.06272-3.18682l-33.4839-34.82842A46.32211,46.32211,0,0,0,916.21229,187.57009Zm-10.42905,55.9852a33.13094,33.13094,0,1,1,.922-46.84516A33.131,33.131,0,0,1,905.78324,243.55529Z",
  transform: "translate(-164.04572 -151.70001)",
  fill: "#504c89"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M858.28282,210.46212c-3.72547,0-3.73167,5.78988,0,5.78988C862.0083,216.252,862.0145,210.46212,858.28282,210.46212Z",
  transform: "translate(-164.04572 -151.70001)",
  fill: "#504c89"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M884.25427,191.914a27.82923,27.82923,0,0,0-24.00514,12.39878c-1.58285,2.47751,2.91112,4.66665,4.48548,2.2024,4.01726-6.28806,11.65182-10.28019,19.90217-10.07358a25.3593,25.3593,0,0,1,20.6949,12.03671c1.58209,2.60731,5.72583.2365,4.15387-2.354C904.43151,197.79545,894.61425,192.1485,884.25427,191.914Z",
  transform: "translate(-164.04572 -151.70001)",
  fill: "#504c89"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 4.90856,
  y: 240.59998,
  width: 867,
  height: 59,
  fill: "#e0e0e0"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 4.90856,
  y: 339.59998,
  width: 867,
  height: 59,
  fill: "#e0e0e0"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 4.90856,
  y: 438.59998,
  width: 867,
  height: 59,
  fill: "#e0e0e0"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 4.90856,
  y: 537.59998,
  width: 867,
  height: 59,
  fill: "#e0e0e0"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f6245ee5-e739-4f07-8284-f5c00440f05d",
    "data-name": "Layer 1",
    width: 871.90856,
    height: 596.59998,
    viewBox: "0 0 871.90856 596.59998",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.7ba75c57.svg";
export { ForwardRef as ReactComponent };